// extracted by mini-css-extract-plugin
export default {"progressBar":"progress-bar_progressBar__iEwnc","bar":"progress-bar_bar__xCkzP","percentage":"progress-bar_percentage__naI2W"};